import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-circles',
  templateUrl: './loader-circles.component.html',
  styleUrls: ['./loader-circles.component.css'],
})
export class LoaderCirclesComponent {}
